import { Cloud } from '@cast/shared-types';
import { CloudAssetIntegrationsScope } from '@cast/types-inventory';

type ScopeOption = {
  label: string;
  value: CloudAssetIntegrationsScope;
};

export const providerToScopeOptions: Record<Cloud, Array<ScopeOption>> = {
  [Cloud.gcp]: [
    {
      label: 'Recommended',
      value: CloudAssetIntegrationsScope.ALL,
    },
    {
      label: 'Minimal',
      value: CloudAssetIntegrationsScope.ALL_MINIMAL_PERMISSIONS,
    },
  ],
  [Cloud.aws]: [
    {
      label: 'Recommended',
      value: CloudAssetIntegrationsScope.ALL,
    },
    {
      label: 'Minimal',
      value: CloudAssetIntegrationsScope.ALL_MINIMAL_PERMISSIONS,
    },
  ],
  [Cloud.azure]: [
    {
      label: 'Recommended',
      value: CloudAssetIntegrationsScope.ALL,
    },
    {
      label: 'Minimal',
      value: CloudAssetIntegrationsScope.ALL_MINIMAL_PERMISSIONS,
    },
  ],
  [Cloud.oracle]: [],
  [Cloud.nebius]: [],
  [Cloud.unknown]: [],
};

export const providerToPermissions: Record<Cloud, string[]> = {
  [Cloud.aws]: [
    'Read-only IAM role — no write access granted',
    '14 read-only permissions across EC2, EKS, and CloudWatch',
    'Role is auto-removed when you disconnect',
  ],
  [Cloud.gcp]: [
    'Read-only IAM role — no write access granted',
    'Viewer role across Compute Engine, GKE, and Cloud Monitoring',
    'Role is auto-removed when you disconnect',
  ],
  [Cloud.azure]: [
    'Read-only IAM role — no write access granted',
    'Reader role across VMs, AKS, and Azure Monitor',
    'Role is auto-removed when you disconnect',
  ],
  [Cloud.oracle]: [],
  [Cloud.nebius]: [],
  [Cloud.unknown]: [],
};
